let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1GH7b")).then(() => parcelRequire('6jxHC'));